/**
 * Maps frontend routes to minimum read permission for menu/route access.
 */
export const PATH_PERMISSION_MAP = {
  "/dashboard": "dashboard.read",
  "/orders": "orders.read",
  "/quotes": "billing.read",
  "/new-quote": "billing.create",
  "/recurring-invoices": "billing.read",
  "/invoice": "billing.read",
  "/receipt": "billing.read",
  "/credit-notes": "billing.read",
  "/customer": "customers.read",
  "/crm": "crm.read",
  "/crm-analytics": "reports.read",
  "/crm-message": "whatsapp.read",
  "/products": "products.read",
  "/grouped-product": "products.read",
  "/category": "products.read",
  "/features": "products.read",
  "/coupon": "products.read",
  "/catlog": "products.read",
  "/catlog-catgeory": "products.read",
  "/expense": "finance.read",
  "/wallet-target": "finance.read",
  "/wallet-history": "finance.read",
  "/departments": "team.read",
  "/team-directory": "staff_management.read",
  "/team-attendance": "team.read",
  "/tasks": "tasks.read",
  "/tasks-2": "tasks.read",
  "/attendance": "attendance.read",
  "/new-staff": "staff_management.create",
  "/setting": "settings.read",
  "/delivery": "settings.read",
  "/pincode": "settings.read",
  "/appearance/themes": "settings.read",
  "/appearance/customize": "settings.read",
  "/footer-setting": "settings.read",
  "/user-records": "user_management.read",
  "/integrations": "settings.read",
  "/admission": "students.read",
  "/admission-form-builder": "students.read",
  "/admission-plans": "students.read",
  "/student-attendance": "students.read",
  "/admission-batches": "students.read",
  "/admission-centers-settings": "students.read",
  "/slider": "website.read",
  "/newarrival": "website.read",
  "/herosection": "website.read",
  "/headline": "website.read",
  "/blog": "website.read",
  "/menus": "website.read",
  "/media": "website.read",
  "/testimonial": "website.read",
  "/brand": "website.read",
  "/plan": "subscription.read",
  "/refer": "email_campaigns.read",
  "/refer-usage": "email_campaigns.read",
};

export function permissionForPath(pathname) {
  if (!pathname) return null;
  const p = pathname.split("?")[0];
  if (PATH_PERMISSION_MAP[p]) return PATH_PERMISSION_MAP[p];

  const entries = Object.entries(PATH_PERMISSION_MAP).sort(
    (a, b) => b[0].length - a[0].length
  );
  for (const [prefix, perm] of entries) {
    if (prefix !== "/" && (p === prefix || p.startsWith(prefix + "/"))) {
      return perm;
    }
  }
  return null;
}

export const ACTION_LABELS = {
  create: "Create",
  read: "View",
  update: "Edit",
  delete: "Delete",
  export: "Export",
  import: "Import",
};

export const MODULE_LABELS = {
  dashboard: "Dashboard",
  orders: "Leads / Orders",
  customers: "Customers",
  follow_ups: "Follow Ups",
  crm: "CRM",
  tasks: "Tasks",
  calendar: "Calendar",
  reports: "Reports",
  staff_management: "Staff Management",
  user_management: "User Management",
  settings: "Settings",
  billing: "Billing",
  subscription: "Subscription",
  whatsapp: "WhatsApp",
  email_campaigns: "Email Campaigns",
  documents: "Documents",
  projects: "Projects",
  products: "Products",
  finance: "Finance",
  team: "Team",
  attendance: "Attendance",
  website: "Website / CMS",
  students: "Students",
};
